import { rellax } from "rellax";
console.log(Rellax);
const Rellax = require("rellax");
export function secAnimation() {

var rellax = new Rellax('.p-top-lead-bg');

}